module.exports = __webpack_public_path__ + "img/amara-60.fa9f432d.png";